'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fadl';
var iconName = 'house-chimney';
var width = 512;
var height = 512;
var aliases = [63499,"home-lg"];
var unicode = 'e3af';
var svgPathData = ['M80.5 202.2l0 245.8c0 17.7 14.3 32 32 32l64 0 0-112c0-35.3 28.7-64 64-64l32 0c35.3 0 64 28.7 64 64l0 112 64 0c17.7 0 32-14.3 32-32l0-245.8-176-164.3-176 164.3zM384.5 72l0 41.6 48 44.8 0-86.4c0-4.4-3.6-8-8-8l-32 0c-4.4 0-8 3.6-8 8z', 'M267.4 4.3c-6.1-5.7-15.7-5.7-21.8 0l-240 224c-6.5 6-6.8 16.2-.8 22.6s16.2 6.8 22.6 .8l21.1-19.7 0 216c0 35.3 28.7 64 64 64l288 0c35.3 0 64-28.7 64-64l0-216 21.1 19.7c6.5 6 16.6 5.7 22.6-.8s5.7-16.6-.8-22.6l-42.9-40.1 0-116.2c0-22.1-17.9-40-40-40l-32 0c-22.1 0-40 17.9-40 40l0 11.7-85.1-79.4zM432.5 72l0 86.4-48-44.8 0-41.6c0-4.4 3.6-8 8-8l32 0c4.4 0 8 3.6 8 8zm0 130.2l0 245.8c0 17.7-14.3 32-32 32l-64 0 0-112c0-35.3-28.7-64-64-64l-32 0c-35.3 0-64 28.7-64 64l0 112-64 0c-17.7 0-32-14.3-32-32l0-245.8 176-164.3 176 164.3zM304.5 480l-96 0 0-112c0-17.7 14.3-32 32-32l32 0c17.7 0 32 14.3 32 32l0 112z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faHouseChimney = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;